import { render, staticRenderFns } from "./TabNavigation.vue?vue&type=template&id=62fec651&scoped=true"
import script from "./TabNavigation.vue?vue&type=script&lang=ts"
export * from "./TabNavigation.vue?vue&type=script&lang=ts"
import style0 from "./TabNavigation.vue?vue&type=style&index=0&id=62fec651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fec651",
  null
  
)

export default component.exports